export const ANALYTICS_SOURCE = {
  LANDING: "Landing",
  DETAILS: "Details",
  MAP: "Map",
  LIST: "List",
} as const;

export const ANALYTICS_SORT_BY = {
  RECOMMENDED: "Recommended",
  DISTANCE: "Distance",
  PRICE: "price",
  REVIEWS: "Reviews",
} as const;

export const ANALYTICS_SEARCH_TYPE = {
  MAP: "Map",
  HOTEL: "Hotel",
  KNOWN_LOCATION: "Known Location",
  NEARBY_LOCATION: "Nearby Location",
  TAG: "Tag",
} as const;

export const ANALYTICS_DETAILS_SECTION = {
  PHOTO: "Photo",
  DESCRIPTION: "Description",
  AMENITIES: "Amenities",
  REVIEWS: "Reviews",
  MAP: "Map",
  FAQ: "Faq",
};
